import type { Routes } from '@angular/router';
import { provideRouter } from '@angular/router';
import { APP_LOGIN, APP_SITO, MENU_FOOD_SERVICE_COMPANY_USER, MENU_REPROTECTION } from './core/utils/constants';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: APP_LOGIN, loadChildren: () => import('./features/login/login.module').then((m) => m.LoginModule) },
  // { path: APP_QR_CODE, loadChildren: () => import('./qr-code-registration/qr-code-registration.module').then(m => m.QrCodeRegistrationModule) },
  // { path: APP_PASSEGGERI, loadChildren: () => import('./passeggeri/passeggeri.module').then(m => m.PasseggeriModule) },
  {
    path: MENU_FOOD_SERVICE_COMPANY_USER,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/food-service-company-user/food-service-company-user.module').then((m) => m.FoodServiceCompanyUserModule),
  },
  {
    path: MENU_REPROTECTION,
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/reprotection/reprotection.module').then((m) => m.ReprotectionModule),
  },
  { path: 'hotac', loadChildren: () => import('./features/hotac/hotac.module').then((m) => m.HotacModule) },
  { path: APP_SITO, loadChildren: () => import('./features/layout/layout.module').then((m) => m.LayoutModule) },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
